'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const useOverflow = () => {
  const [isOverflowing, setIsOverflowing] = React.useState(false);
  const [node, setNode] = React.useState(null);
  React.useEffect(() => {
    if (node) {
      const offsetHeight = node.offsetHeight;
      const scrollHeight = node.scrollHeight;
      if (scrollHeight - offsetHeight > 2) {
        setIsOverflowing(true);
      }
    }
  }, [node]);
  return [isOverflowing, setNode];
};

exports.useOverflow = useOverflow;
//# sourceMappingURL=useOverflow.cjs.js.map
